/* eslint-disable array-callback-return */
import './index.css'
import { DesktopNavbar } from '../NavBar/Desktop/DesktopNavbar'
import {useState, useEffect, useRef} from 'react'
import "react-datepicker/dist/react-datepicker.css";
import beef from '../../assets/beef.svg'
import makanan1 from '../../assets/makanan1.png'
import makanan2 from '../../assets/makanan2.png'
import { useNavigate } from "react-router-dom";
import pork from '../../assets/pork.svg'
import star from '../../assets/star.svg'
import stove from '../../assets/stove.svg'
import microwave from '../../assets/microwave.svg'
import circleback from '../../assets/circleback.svg'
import oven from '../../assets/oven.svg'
import carleft from '../../assets/carleft.svg'
import carright from '../../assets/carright.svg'
import { CSSTransition } from 'react-transition-group';
import spinner from '../../assets/spinner.gif'
import axios from 'axios';
import { baseUrl } from '../../lib/api';

export const PageDetailMenu = () => {

    const [detail, setDetail] = useState()
    const [loading, setLoading] = useState(true)
    const [showNavPopup, setShowNavPopup] = useState(false)
    const firstUpdate2 = useRef(true);
    useEffect(() =>{
        window.scrollTo(0, 0)
        setLoading(true)
        const menuDetailFromDB = async () => {
            try {
                const data = await callApigetMenuDetail()
                setDetail(data)
            } catch (error) {
                console.log("Error menuDetailFromDB")
            }
        }
        menuDetailFromDB()
        localStorage.setItem('nav', 'fnd')
    },[])

    useEffect(() => {
        if (firstUpdate2.current) {
            firstUpdate2.current = false;
        }else{
            setLoading(false)
        }
    },[detail])

    const [menu, setMenu] = useState(1)
    const [standby, setstandby] = useState(true)
    const firstUpdate = useRef(true);
    const history = useNavigate()

    useEffect(()=>{
        
        if(standby===false){
            setTimeout(function() {
                history('/category/chefList/detailChef/detailMenu/setSchedule');
           }, 500);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[standby])

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
          } else {
            var elem = document.getElementById('DMPcardimg');
            elem.style.transition = "background-image 0.5s";
            elem.style.backgroundImage = `url(${detail.menu[menu-1].gambar})`;
          }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[menu])

    const ubahGambar = (e) => {
        if(e === "kiri"){
            if(menu===1){
                setMenu(detail.menu.length)
            }else{
                setMenu(menu-1)
            }
        }else{
            if(menu===detail.menu.length){
                setMenu(1)
            }else{
                setMenu(menu+1)
            }
        }
    }

    const handleCloseAll = () => {
        setShowNavPopup(false)
    }

    const menuParser = (menus) => {
        const parsedMenus = menus.map((el, idx) => {
            return {
                nama: el.name,
                gambar: idx === 1 ? makanan1 : makanan2
            }
        })
        return parsedMenus
    }

    const parseMenuDetail = (menuDetail) => {
        menuDetail = menuDetail.map((el) => {
            return {
                chef: el.chef_name,
                rate: el.chef_rating ? el.chef_rating : "N/A",
                jenis: "Asian Food",
                max: el.max_pax,
                bahan: ["pork","beef"],
                harga: 150,
                tool: ['Oven','Microwave','Stove'],
                menu: menuParser(el.menus)
            }
        })
        return menuDetail[0]
    }

    const callApigetMenuDetail = async () => {
        try {
            const { data: res } = await axios({
                method: 'get',
                url: `${baseUrl}chef/Chef-Taplak/anniversary-pik`
            })
            const menuDetail = [res.data]
            const parsedMenuDetail = parseMenuDetail(menuDetail)
            return parsedMenuDetail
        } catch (error) {
            console.log("error getMenuDetailFromDB")
            // Create error handler (pop-up or something)
        }
    } 
    
    return (
        <div onClick={e => {e.stopPropagation();handleCloseAll()}} id="maincontainer" style={{minWidth:"100%", minHeight:"100vh", backgroundColor:"#111111", position:"relative", overflow:"unset"}}>
            <DesktopNavbar showPopup={showNavPopup} setShowPopup={setShowNavPopup}></DesktopNavbar>
            <img onClick={e => {e.preventDefault();e.stopPropagation();history(-1)}} className='backmobile' alt="back" src={circleback}></img>
            {
                !loading && (
                <CSSTransition in={standby} timeout={{appear:1000,enter:2000,exit:1000}} mountOnEnter={true} appear={true} classNames="DMPtrans">
                <div className='flex DMPbuttonmobile' onClick={e => {e.preventDefault();e.stopPropagation();history("/category/chefList/detailChef/detailMenu/setSchedule")}}>
                    <p className='small bold' style={{marginLeft:"auto",marginRight:"auto"}}>Choose This Menu</p>
                    <p className='tiny normal' style={{marginLeft:"auto",marginRight:"auto"}}>Start from IDR {detail.harga}/Pax</p>
                </div>
                </CSSTransition>
                )
            }
            {
                loading?
                <img alt='loading' className='taplakLoading' src={spinner}></img>
                :
                <CSSTransition in={standby} timeout={{appear:1000,enter:2000,exit:1000}} mountOnEnter={true} appear={true} classNames="DMPtrans">
                <div className='DMPkontenkontainer flex'>

                    <div className='DMPkontenkiri flex'>
                        <div className='DMPmenunav flex'>
                            <p className='bold white medium'>Menu</p>
                            <img onClick={() => ubahGambar("kiri")} src={carleft} alt="icon" className='DMPiconnav1'></img>
                            <p className='bold white medium'>{menu} <span className='white medium normal'>of {detail.menu.length} </span></p>
                            <img onClick={() => ubahGambar("kanan")} src={carright} alt='icon' className='DMPiconnav2'></img>
                        </div>

                        <div className='DMPcardkontainer flex'>
                            <div id='DMPcardimg' style={{backgroundImage:`url(${detail.menu[0].gambar})`}} className='DMPcardatas'></div>
                            <div className='DMPcardbawah'>
                                <p className='medium white bold'>{detail.menu[menu-1].nama}</p>
                                <p className='small white normal' style={{marginTop:"24px"}}>This Set Menu Contains</p>
                                <div className='flex' style={{marginTop:"24px"}}>
                                    {
                                        detail.bahan.map((post) => {
                                            if(post==="beef"){
                                                return(<div style={{display:"flex", flexDirection:"column", marginRight:"24px"}}>
                                                            <img alt="icon" src={beef} className='DMPiconcard' style={{marginLeft:"auto", marginRight:"auto", marginBottom:"4px"}}></img>
                                                            <p className='small white normal' style={{textAlign:"center"}}>Beef</p>
                                                        </div>)
                                            }else if(post==="pork"){
                                                return(<div style={{display:"flex", flexDirection:"column",marginRight:"24px"}}>
                                                            <img alt="icon" src={pork} className='DMPiconcard' style={{marginLeft:"auto", marginRight:"auto", marginBottom:"4px"}}></img>
                                                            <p className='small white normal' style={{textAlign:"center"}}>Pork</p>
                                                        </div>)
                                            }
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='DMPkontenkanan'>
                        <p className='big bold white'>{detail.jenis}</p>
                        <div className='flex'>
                            <p className='medium normal white'>By <span className='bold'>Chef {detail.chef}</span></p>
                            <img alt='icon' src={star} className='DMPiconnav1'></img>
                            <p className='medium normal white'>{detail.rate}</p>
                        </div>
                        <div style={{height:"1px",backgroundColor:"#6F6F6F", marginTop:"16px"}}></div>
                        <p className='small white marginbig'>Menu</p>
                        <p className='small white bold'>
                            {
                                detail.menu.map((post) => {
                                    if(post.nama === detail.menu[0].nama){
                                        return(<span>{post.nama}</span>)

                                    }else{
                                        return(<span>, {post.nama}</span>)
                                    }
                                })
                            }
                        </p>
                        <p className='small normal white marginbig'>Maximal guest</p>
                        <p className='small bold white'>{detail.max} guest</p>
                        <p className='small normal white marginbig'>Required kitchen tools</p>
                        <p style={{color:"#AAAAAA", fontSize:"14px",margin:"0"}}>This Set Menu requires the following tools to be available for use in the Venue.</p>
                        <div className='flex marginbig'>{
                            detail.tool.map((post) => {
                                if(post==="Oven"){
                                    return(<div style={{display:"flex", flexDirection:"column", marginRight:"24px"}}>
                                                <img alt="icon" src={oven} className='DMPiconcard' style={{marginLeft:"auto", marginRight:"auto", marginBottom:"4px"}}></img>
                                                <p className='small white normal' style={{textAlign:"center"}}>Oven</p>
                                            </div>)
                                }else if(post==="Stove"){
                                    return(<div style={{display:"flex", flexDirection:"column",marginRight:"24px"}}>
                                                <img alt="icon" src={stove} className='DMPiconcard' style={{marginLeft:"auto", marginRight:"auto", marginBottom:"4px"}}></img>
                                                <p className='small white normal' style={{textAlign:"center"}}>Stove</p>
                                            </div>)
                                }else if(post==="Microwave"){
                                    return(<div style={{display:"flex", flexDirection:"column",marginRight:"24px"}}>
                                                <img alt="icon" src={microwave} className='DMPiconcard' style={{marginLeft:"auto", marginRight:"auto", marginBottom:"4px"}}></img>
                                                <p className='small white normal' style={{textAlign:"center"}}>Microwave</p>
                                            </div>)
                                }
                            })
                        }</div>

                        <div onClick={() => setstandby(false)} className='flex DMPbutton'>
                            <p className='small bold' style={{marginLeft:"auto",marginRight:"auto"}}>Choose This Menu</p>
                            <p className='tiny normal' style={{marginLeft:"auto",marginRight:"auto"}}>Start from IDR {detail.harga}/Pax</p>
                        </div>
                    </div>
                </div>
                </CSSTransition>
            }
        </div>
    )
  }